import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "../../node_modules/react-builder/dist/widgets/BaseComponent";
import { ContainerAttributes } from "../../node_modules/react-builder/dist/widgets/Container";
import { FontTheme } from "../../node_modules/react-builder/dist/attributes/FontTheme";
import { useContext, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { BorderAttributes } from "../../node_modules/react-builder/dist/attributes/Border";
import { ConfigContext } from "../../node_modules/react-builder/dist/providers/Content";

@AttributeGroup({ title: 'Input', blockName: 'Input' })
export class InputAttributes extends Attribute {

    @AttributeProperty({ type: 'String' })
    name: string = '';

    @AttributeProperty({ type: 'String' })
    label?: string;

    @AttributeProperty({ type: 'Select', selectOptions: ['text', 'email', 'password', 'tel', 'number', 'checkbox'] })
    type: string = 'text';

    @AttributeProperty({ type: 'String' })
    placeholder?: string;

    @AttributeProperty({ type: 'String' })
    defaultValue?: string;

    @AttributeProperty({ type: 'String' })
    error: string = 'Invalid input';

    @AttributeProperty({ type: 'String' })
    pattern?: string;

    @AttributeProperty({ type: 'Boolean' })
    required: boolean = true;

    @AttributeProperty({ type: 'String' })
    maxLength?: string;

    @AttributeProperty({ type: 'String' })
    minLength?: string;

    @AttributeProperty({ type: 'Image' })
    prefix?: string;

    @AttributeProperty({ type: 'Image' })
    postfix?: string;

    @AttributeProperty({ type: 'Object', cssTarget: '.form_group input, &.form_group label' })
    font: FontTheme = new FontTheme();

    @AttributeProperty({ type: 'Object', cssTarget: '.form_group .input-error-msg' })
    errorFont: FontTheme = new FontTheme();

    @AttributeProperty({ type: 'Object', cssTarget: '.form_group' })
    inputContainer: ContainerAttributes = new ContainerAttributes().fromJSON({ border: new BorderAttributes().fromJSON({ width: '1px' }) })

}

const InputTheme = styled.label((props: { attributes: InputAttributes }) => `

    display: flex;
    align-items: flex-end;
    margin-bottom: 10px;
    position: relative;
    width: 100%;
    font-size: 16px;
    z-index: 2;

    &.form_group label {
        position: absolute;
        line-height: normal;
        z-index: 1;
        color: #666;
        top: normal;
        transition: 0.35s ease;
        cursor: text;
        top: 25%;
        }

        &.rtl.form_group label {
        left: initial;
       
        }

        &.form_group label span {
        
        }

        &.form_group.active label {
        
        
        }

        &.rtl.form_group.active label {
        left: initial;
     

        }

    &.form_group.active label {
        top: -1px;
    background: white;
    line-height: 0;
     padding: 2.5px;
        color: #222;
    }

    &.form_group label {
        z-index: 10;
        pointer-events: none;
        line-height: 0;
    top: 50%;
    }

    .input-error-msg {
        color: red;
        float: right;
        text-align: right;
        font-size: 70%;
        position: absolute;
        right: 0;
        bottom: -17px;
        pointer-events: none;
    }

    &.form_group input{

        border: none;
        padding: 0;
        line-height: normal;
        min-height: unset;  
        min-width: 0;
        flex: 1;

        &:focus{
            outline: none;
            border: none;
            box-shadow: none;
        }
    }

    i[postfix],
    i[prefix] {
        z-index: 10;
        display: flex;
    }

    i[prefix] {
        left: 5px;
    }

    ${props.attributes.toCSS()}

`);

export function Input(props: ComponentProps<InputAttributes>) {

    const { register, formState: { errors }, control, getValues } = useFormContext();
    const [isFocused, setIsFocused] = useState(false);

    const content = useContext(ConfigContext);

    const defaultError = `${props.attributes.label} field is required`;
    const buildValidator = () => {
        const v: any = {};

        if (props.attributes.maxLength) {
            v.maxLength = (v: any) =>
                v.length <= parseInt(props.attributes.maxLength!) || defaultError;
        }
        if (props.attributes.minLength) {
            v.maxLength = (v: any) =>
                v.length >= parseInt(props.attributes.minLength!) || defaultError;
        }

        if (props.attributes.type == 'email') {
            v.matchPattern = (v: any) =>
                !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                defaultError;

        }
        if (props.attributes.pattern) {
            v.matchPattern = (v: any) =>
                RegExp(props.attributes.pattern!).test(v) ||
                defaultError;
        }

        return v;
    }

    const hasValue = () => {
        return getValues(props.attributes.name);
    }

    return (
        <InputTheme {...props} className={`form_group ${isFocused && 'focus'} ${(isFocused || hasValue()) && 'active'}`} attributes={props.attributes}>
            {props.attributes.prefix && <img src={props.attributes.prefix} />}


            <Controller
                name={props.attributes.name}
                control={control}
                defaultValue={props.attributes.defaultValue}
                rules={{
                    required: props.attributes.required && defaultError,
                    validate: buildValidator(),
                    // maxLength: parseInt(props.attributes.maxLength ?? ''),
                    // minLength: parseInt(props.attributes.minLength ?? ''),
                }}
                render={({ field: { ref, ...field }, fieldState }) => <input
                    type={props.attributes.type}
                    ref={ref}
                    {...field}
                    onFocus={(e) => setIsFocused(true)}
                    onBlur={(e) => setIsFocused(false)}
                    //   click="form.clear"
                    //   keypress="keypress.emit$event"
                    //   keyup="keyup.emit$event"
                    //   change="change.emit$event"
                    //   #input
                    name={props.attributes.name}
                    required={props.attributes.required}
                    placeholder={props.attributes.placeholder}
                    maxLength={parseInt(props.attributes.maxLength ?? '')}
                    minLength={parseInt(props.attributes.minLength ?? '')}

                />} />
            {props.attributes.label && <label style={{ left: 'auto' }}>{content.parseContent(props.attributes.label??'')}</label>}
            {errors[props.attributes.name]?.message && <div className="input-error-msg" >
                {content.parseContent(props.attributes.error)}
            </div >}
            {props.attributes.prefix && <img src={props.attributes.prefix} />}

        </InputTheme >
    )
}


Input.prototype.Props = InputAttributes;


export default Input;